module.exports = __webpack_public_path__ + "img/icon-chevron-right-calendar.1d0d7da3.svg";